import PropTypes from "prop-types"
import React from "react"
import { Transition } from "react-transition-group"

function SlideDown({
  children,
  defaultStyles,
  transitionStyles,
  duration,
  open,
  ...rest
}) {
  return (
    <Transition in={open} timeout={duration} appear unmountOnExit mountOnEnter>
      {state => (
        <div
          {...rest}
          style={{
            position: "relative",
            ...defaultStyles,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  )
}

SlideDown.defaultProps = {
  duration: 300,
}

SlideDown.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  duration: PropTypes.number,
}

export default SlideDown
